
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chatgpt-web-ui",
      function () {
        return require("private-next-pages/chatgpt-web-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chatgpt-web-ui"])
      });
    }
  